// TaraErrorPopup.tsx
import React from 'react';
import CustomSVGs from '../../../ui/customSVGs/CustomSVGs';
import { warningSVG } from '../../../lib/allCustomSVGs';
import MainSquareButton from '../../../ui/buttons/MainSquareButton';
import { useTranslation } from 'react-i18next';
import '../../../styles/pages/tara/taraUI/taraErrorPopup.scss';

interface TaraErrorDetails {
  errorCode?: string | null;
  responseMessage?: string | null;
  chatId?: string | number | null | undefined;
  responseId?: string | null;
  traceId?: string | null;
  userMessage?: string;
  onRetry?: () => void;
  onNewChat?: () => void;
}

const TaraErrorPopup: React.FC<TaraErrorDetails> = ({
  errorCode,
  responseMessage,
  chatId,
  responseId,
  traceId,
  userMessage,
  onRetry,
  onNewChat,
}) => {
  const { t } = useTranslation();

  return (
    <div className='taraErrorPopup'>
      <div className='taraErrorPopup__titles'>
        <div className='taraErrorPopup__titles--icon'>
          <CustomSVGs svg={warningSVG} />
        </div>
        <div className='taraErrorPopup__titles--content'>
          <h2 className='taraErrorPopup__titles--title'>
            {t('TaraErrorPopupTitle')}
          </h2>
          <p className='taraErrorPopup__titles--subtitle'>
            {t('TaraErrorPopupSubtitle')}
          </p>
        </div>
      </div>

      <div className='taraErrorPopup__error'>
        <span className='taraErrorPopup__error--title'>
          {t('ErrorDetails')}
        </span>
        <div className='taraErrorPopup__error--details'>
          {errorCode && (
            <div className='taraErrorPopup__error--details-item'>
              <span className='taraErrorPopup__error--details-item-label'>
                Error Type:
              </span>
              <span className='taraErrorPopup__error--details-item-value'>
                {errorCode}
              </span>
            </div>
          )}
          {responseMessage && (
            <div className='taraErrorPopup__error--details-item'>
              <span className='taraErrorPopup__error--details-item-label'>
                Response:
              </span>
              <span className='taraErrorPopup__error--details-item-value'>
                {responseMessage}
              </span>
            </div>
          )}
          {userMessage && (
            <div className='taraErrorPopup__error--details-item'>
              <span className='taraErrorPopup__error--details-item-label'>
                Issue:
              </span>
              <span className='taraErrorPopup__error--details-item-value'>
                {userMessage}
              </span>
            </div>
          )}
          {chatId && (
            <div className='taraErrorPopup__error--details-item'>
              <span className='taraErrorPopup__error--details-item-label'>
                Chat ID:
              </span>
              <span className='taraErrorPopup__error--details-item-value'>
                {chatId}
              </span>
            </div>
          )}
          {responseId && (
            <div className='taraErrorPopup__error--details-item'>
              <span className='taraErrorPopup__error--details-item-label'>
                Response ID:
              </span>
              <span className='taraErrorPopup__error--details-item-value'>
                {responseId}
              </span>
            </div>
          )}
          {traceId && (
            <div className='taraErrorPopup__error--details-item'>
              <span className='taraErrorPopup__error--details-item-label'>
                Trace ID:
              </span>
              <span className='taraErrorPopup__error--details-item-value'>
                {traceId}
              </span>
            </div>
          )}
        </div>
      </div>

      <div className='taraErrorPopup__message'>
        <p className='taraErrorPopup__message--text'>
          {t('TaraErrorPopupMessage')}
        </p>
      </div>

      <div className='taraErrorPopup__buttons'>
        <div className='taraErrorPopup__buttons--1'>
          <MainSquareButton
            value={t('StartNewChat')}
            type='button'
            buttonType='white'
            onClick={onNewChat}
          />
        </div>
        <div className='taraErrorPopup__buttons--2'>
          <MainSquareButton
            value={t('TryAgain')}
            type='button'
            onClick={onRetry}
          />
        </div>
      </div>
    </div>
  );
};

export default TaraErrorPopup;
